function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import CircularProgress from '@material-ui/core/CircularProgress';
import classes from '../badge-number.scss';
import appearAnimClasses from './appear.anim.scss';
export default class Spinner extends React.PureComponent {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.isLoading !== nextProps.isLoading) {
      const hasLoaded = prevState.isLoading && !nextProps.isLoading;
      return {
        isLoading: nextProps.isLoading,
        prevIsLoading: prevState.isLoading,
        hasLoaded: hasLoaded || prevState.hasLoaded,
        progress: 0
      };
    }
    return null;
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "props", void 0);
    _defineProperty(this, "state", void 0);
    _defineProperty(this, "timer", void 0);
    _defineProperty(this, "hasLoadedTimeout", void 0);
    _defineProperty(this, "getProgressToAdd", progress => {
      return progress > 75 ? progress + 9 : progress + 3;
    });
    _defineProperty(this, "tick", () => {
      this.setState(prevState => {
        const {
          hasLoaded,
          progress,
          isLoading
        } = prevState;
        if (!isLoading && !hasLoaded) {
          return null;
        }
        const addedProgress = this.getProgressToAdd(progress);
        let nextProgress = addedProgress >= 100 ? 100 : addedProgress;
        if (progress >= 100 && !hasLoaded) {
          nextProgress = 0;
        }
        return {
          progress: nextProgress
        };
      });
    });
    this.state = {
      // @todo. auto generated. fix this error
      // @ts-ignore
      isLoading: null,
      // @todo. auto generated. fix this error
      // @ts-ignore
      prevIsLoading: null,
      hasLoaded: false,
      progress: 0
    };
    this.timer = null;
  }
  componentDidUpdate() {
    const {
      isLoading,
      hasLoaded
    } = this.state;
    if (isLoading || hasLoaded) {
      clearInterval(this.timer);
      this.timer = setInterval(this.tick, 40);
    }
    if (hasLoaded) {
      clearTimeout(this.hasLoadedTimeout);
      this.hasLoadedTimeout = setTimeout(() => this.setState({
        hasLoaded: false
      }), 2000);
    }
    setTimeout(() => {
      this.setState(prevState => {
        const {
          isLoading,
          hasLoaded,
          progress
        } = prevState;
        if (!isLoading && !hasLoaded && progress >= 100) {
          clearInterval(this.timer);
          return {
            progress: 0
          };
        }
      });
    }, 50);
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  render() {
    const {
      isLoading,
      hasLoaded,
      progress
    } = this.state;
    const {
      spinnerClassName
    } = this.props;
    return /*#__PURE__*/React.createElement(CSSTransition, {
      classNames: appearAnimClasses,
      in: isLoading || hasLoaded,
      timeout: 800,
      unmountOnExit: true
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.spinnerWrapper
    }, /*#__PURE__*/React.createElement(CircularProgress, {
      variant: "determinate",
      value: progress,
      size: 52,
      color: "secondary",
      classes: {
        root: classnames(classes.progress, spinnerClassName)
      }
    })));
  }
}